import React from 'react';
import * as R from 'ramda';
import { connect } from 'react-redux';
import { pure, compose, withHandlers } from 'react-recompose';
// components
import TextComponent from '../../../components/text';
// features
import { setExpandedContainerOptions } from '../../expanded-container/actions';
// helpers/constants
import * as G from '../../../helpers';
import * as GC from '../../../constants';
// icons
import * as I from '../../../svgs';
// ui
import { IconWrapper } from '../../../ui';
// utilities
import routesMap from '../../../utilities/routes';
//////////////////////////////////////////////////

// NOTE: name here actually is prop value

const convertors = {
  [GC.FIELD_WEIGHT]: (name) => G.fromKgsToPounds(name, 2),
  [GC.FIELD_DISTANCE]: (name) => G.fromKmsToMiles(name, 2),
  [GC.FIELD_ITEM_VOLUME]: (name) => G.fromCubicMeterToFeet(name, 2),
  [GC.FIELD_TEMPERATURE]: (name) => G.fromCelsiusToFahrenheit(name, 2),
};

const getValue = ({ type, uomSystem, fieldData }) => {
  if (R.equals(uomSystem, GC.METRIC_SYSTEM)) return G.mathRoundNumber(fieldData);

  return convertors[type](fieldData);
};

const metricUOMs = {
  [GC.FIELD_WEIGHT]: GC.UOM_KILOGRAM,
  [GC.FIELD_TEMPERATURE]: GC.UOM_CELSIUS,
  [GC.FIELD_DISTANCE]: GC.UOM_KILOMETER_LABEL,
  [GC.FIELD_ITEM_VOLUME]: GC.UOM_CUBIC_METERS,
};

const imperialUOMs = {
  [GC.FIELD_WEIGHT]: GC.UOM_POUND,
  [GC.FIELD_DISTANCE]: GC.UOM_MILE_LABEL,
  [GC.FIELD_ITEM_VOLUME]: GC.UOM_CUBIC_FEET,
  [GC.FIELD_TEMPERATURE]: GC.UOM_FAHRENHEIT,
};

export const BooleanTableField = ({ value }) => G.ifElse(
  G.isTrue(value),
  I.uiTrue,
  I.uiFalse,
)();

export const TableField = ({ data, type }) => {
  const { fieldData } = data;

  const uomSystem = G.getConfigGeneralUomCalcDefaultUomSystemFromWindow();

  if (G.isNilOrEmpty(fieldData)) return null;

  const value = getValue({ type, uomSystem, fieldData });
  const uom = G.ifElse(R.equals(uomSystem, GC.METRIC_SYSTEM), metricUOMs[type], imperialUOMs[type]);

  return <span>{value} {uom}</span>;
};

export const UomLocalesTableField = ({ data, field }) => {
  const text = R.compose(
    R.join(', '),
    R.map((item) => G.getUomLocale(item)),
    R.pathOr([], [field]),
  )(data);

  return (
    <TextComponent title={text} display='block' maxWidth='100%' withEllipsis={true}>
      {text}
    </TextComponent>
  );
};

const expandedDetailsEnhance = compose(
  connect(null, { setExpandedContainerOptions }),
  withHandlers({
    handleOpenDetails: (props) => () => {
      const { guid, loadType, setExpandedContainerOptions, expandedContainerAdditionalOptions } = props;

      const loadTypeClo = G.isLoadTypeClo(loadType);
      const componentType = G.ifElse(
        loadTypeClo,
        GC.PAGE_DISPATCH_DETAILS_NEW_ORDER,
        GC.PAGE_DISPATCH_DETAILS_NEW_LOAD,
      );
      const openLoadInSidebar = G.getAmousConfigByNameFromWindow(GC.UI_OPEN_LOAD_IN_SIDEBAR);

      const route = G.ifElse(loadTypeClo, routesMap.dispatchDetailsOrder, routesMap.dispatchDetailsLoad)({ guid });

      if (G.isFalse(openLoadInSidebar)) return G.goToRoute(route);

      return setExpandedContainerOptions({
        opened: true,
        componentType,
        visitPageGuid: guid,
        options: expandedContainerAdditionalOptions,
      });
    },
  }),
  pure,
);

export const ExpandedDetails = expandedDetailsEnhance(({ handleOpenDetails }) => (
  <IconWrapper
    cursor='pointer'
    onClick={handleOpenDetails}
    title={G.getWindowLocale('actions:go-to-details', 'Go to Details')}
  >
    {I.routesLoads(G.getTheme('tables.rows.iconColor'))}
  </IconWrapper>
));
